import { render, staticRenderFns } from "./RichTextBoxObject.vue?vue&type=template&id=220b986c&scoped=true&"
import script from "./RichTextBoxObject.vue?vue&type=script&lang=ts&"
export * from "./RichTextBoxObject.vue?vue&type=script&lang=ts&"
import style0 from "./RichTextBoxObject.vue?vue&type=style&index=0&id=220b986c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220b986c",
  null
  
)

export default component.exports